<template>
  <div class="Index">

    <headNav :activeNav="'Inicio'"></headNav>

    <Inicio></Inicio>

    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import Inicio from "@/components/Inicio.vue";

import footPage from "@/components/foot.vue";

export default {
  name: 'Index',
  components: { headNav, Inicio, footPage },
  data () {
    return {
      activeNav: "Inicio",
    }
  },
  created() {
    let nav = localStorage.getItem('activeNav');
    if (nav) {
      this.activeNav = nav;
    } else {
      localStorage.setItem('activeNav', this.activeNav);
    }
  },
  methods: {
    // getActiveNav(val) {
    //   this.activeNav = val;
    // }
  }
}
</script>

<style scoped>
.Index {
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin: 0;
  padding: 0;
}
</style>
